import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, InfoLabel } from '../../../../common/components';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import { get } from 'lodash';
import { InternalButtonBar } from '../../../layout/components/InternalButtonBar/InternalButtonBar';
import { Col, Row } from 'react-bootstrap';

export default class SourceShow extends Component {
  static propTypes = {
    resource: PropTypes.object.isRequired,
  };

  render() {
    const resource = this.props.resource.data;
    const broker = getIncludedResource(
      this.props.resource.data,
      this.props.resource.included,
      'broker',
    );
    const channel = getIncludedResource(
      this.props.resource.data,
      this.props.resource.included,
      'channel',
    );
    const organisation = getIncludedResource(
      this.props.resource.data,
      this.props.resource.included,
      'organisation',
    );
    const sourceType = getIncludedResource(
      this.props.resource.data,
      this.props.resource.included,
      'source_type',
    );

    return (
      <Box>
        <Row>
          <Col sm={12}>
            <h2>{resource.attributes.name}</h2>
          </Col>
        </Row>

        <InfoLabel label="Name" value={resource.attributes.name} labelSize={2} />

        <InfoLabel
          label="Type"
          labelSize={2}
          value={get(sourceType, 'data.attributes.name')}
        />
        <InfoLabel label="Status" labelSize={2} value={resource.attributes.status} />

        <Row>
          <Col sm={12}>
            <div className="hr" />
          </Col>
        </Row>
        {get(broker, 'data.attributes.name') && (
          <InfoLabel
            label="Broker"
            value={get(broker, 'data.attributes.name')}
            labelSize={2}
          />
        )}
        {get(organisation, 'data.attributes.name') && (
          <InfoLabel
            label="Organisation"
            value={get(organisation, 'data.attributes.name')}
            labelSize={2}
          />
        )}
        {get(channel, 'data.attributes.name') && (
          <InfoLabel
            label="Channel"
            value={get(channel, 'data.attributes.name')}
            labelSize={2}
          />
        )}

        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['marketing.source_create'],
                  button: (
                    <Button
                      link
                      to={'/admin/sources/' + resource.id + '/edit'}
                      className="pull-right"
                      bsStyle="primary"
                      rightIcon="pencil-square-o"
                      label="edit source"
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </Box>
    );
  }
}
